/**
 * Interpret `settings.branches_enabled` value (API may send string, number, or bool).
 * When missing / empty → default multi-branch (matches backend ShopSettings).
 */
export function branchesMultiFromSettingValue(raw: unknown): boolean {
  if (raw === null || raw === undefined) {
    return true;
  }
  if (typeof raw === "boolean") {
    return raw;
  }
  if (typeof raw === "number") {
    return raw !== 0;
  }
  const v = String(raw).trim().toLowerCase();
  if (v === "") {
    return true;
  }

  return !["0", "false", "no", "off"].includes(v);
}

export function branchesMultiFromSettingsRows(
  rows: { key: string; value: unknown }[] | undefined,
): boolean {
  const raw = rows?.find((r) => r.key === "branches_enabled")?.value;

  return branchesMultiFromSettingValue(raw);
}
